import $ from 'jquery';
import zip from 'lib/util/zip';
import ctaTypes from './cta.types';
import dealerSearchModal from './dealer.search.modal';
import cookies from 'utils/cookies';
import zipTools from 'components/zip-tools';
import tdaConfig from 'lib/util/tda.config';
import PageCache from 'lib/page-cache';
import kac from 'lib/tda/kac';
import liveperson from 'features/liveperson/liveperson';

var __type = ctaTypes.chat;
var __oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
var __providerId = tdaConfig.chat.provider_id;
var __cookieName = 'dealer_code_cao';

function __savedDealerCode() {
  return cookies.getItem(__cookieName);
}

/*
  TODO:
  1) Pages:
    error-404 does not use features/ctas funcs but it can
*/

var chatCta = {
  // dealerSelect invoked via dealer.search.modal, after dealer select within modal
  dealerSelect: function (e, selectedDealer) {
    e.preventDefault();
    this.doChat(selectedDealer.dealerCode);
  },

  doChat: function doChat(dealerCode) {
    var chatUrl = '//buyatoyota.contactatonce.com/caoclientcontainer.aspx?ProviderId=' + __providerId + '&MerchantId=' + dealerCode + '&PlacementId=1&OriginationUrl=' + encodeURIComponent(window.location.href);
    cookies.setItem(__cookieName, String(dealerCode), __oneYear, '/', zipTools.getCrossDomainCookieDomain());
    window.open(chatUrl, 'CAO', 'resizable=yes,toolbar=no,menubar=no,location=no,scrollbars=no,status=no,height=400,width=600');
  },

  changeZipListen: function () {
    PageCache.on('ZIP_CODE_CHANGED', function () {
      cookies.removeItem(__cookieName, '/', zipTools.getCrossDomainCookieDomain());
    });
  }
};

Object.setPrototypeOf(chatCta, dealerSearchModal);

export default function ($scope, dealercode, dealerTdaCode) {
  var $ctaScope = $scope || $('body');
  var $ctas = $(`a[data-destination="${__type}"]`, $ctaScope);

  if (!$ctas.length) return;
  /*
    if we're trying to output a live-chat CTA within the results of
    a dealer that isn't FROM the current TDA, we need to disable it
    just like we do in the PCM
  */
  if (dealerTdaCode && dealerTdaCode !== tdaConfig.tda.code) {
    $ctas.attr('disabled', 'disabled');
    return;
  }

  // KAC handling
  if (tdaConfig.tda.code === 'KAC10') {
    $ctas.addClass('etsChatButton');
    $ctas.attr('data-destination', 'live-chat-kac');
    kac.dealerChat();
    return;
  }

  // This is for all the TDAs currently using LivePerson as the chat provider
  // Currently: NCA, CAT, CON, TRI, TRE, UST, GNY, CHI
  // Set in tda_config.xml: BATSiteConfig.isLivePerson
  if (BATSiteConfig.isLivePerson) {
    $ctas.addClass('livePersonChatButton');
    $ctas.attr('data-destination', 'live-chat-liveperson');
    // the actual CTA needs the data-dealercode as well
    $ctas.attr('data-dealercode', dealercode);
    liveperson.dealerChat(String(dealercode), 1);
    return;
  }

  // Once a user selects a chat provider, that dealer is saved in a cookie
  // If they ever change their zip, we remove that cookie
  if (__savedDealerCode()) chatCta.changeZipListen();

  if (dealercode) $ctas.data('dealercode', dealercode);

  $ctas.on('click', function (e) {
    e.preventDefault();
    var directDealerCode = $(this).data('dealercode');
    var cookiedCode = __savedDealerCode();

    if (directDealerCode) {
      chatCta.doChat(directDealerCode);
    } else if (cookiedCode) {
      chatCta.doChat(cookiedCode);
    } else {
      chatCta.setMode('pma');
      chatCta.beginSearch(zip.getCookiedDefaultFallback());
    }
  });
};
